import { render, staticRenderFns } from "./PaySectionForm.vue?vue&type=template&id=4795048a&scoped=true&"
import script from "./PaySectionForm.vue?vue&type=script&lang=js&"
export * from "./PaySectionForm.vue?vue&type=script&lang=js&"
import style0 from "./PaySectionForm.vue?vue&type=style&index=0&id=4795048a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4795048a",
  null
  
)

export default component.exports